export default "__VITE_ASSET__3f4ee623__"